// Демо-форма гранулярных подсказок по ФИО

import helper from "../domain/name";
import utils from "../utils";
import createComponent from "../vue";
import SuggestionsService from "./service";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

const STATE = {
    fio: null,
    type: "NAME",
};

const service = new SuggestionsService("NAME");

const properties = {
    genderWithSign() {
        return helper.genderWithSign(this.fio);
    },

    good() {
        return helper.isGood(this.fio);
    },

    validationMessage() {
        return helper.validationMessage(this.fio);
    },
};

const methods = {
    initSuggestions(serviceUrl, token) {
        const $surname = $(this.$refs.surname);
        this.initPartialSuggestions($surname, "SURNAME", serviceUrl, token);
        const $name = $(this.$refs.name);
        this.initPartialSuggestions($name, "NAME", serviceUrl, token);
        const $patronymic = $(this.$refs.patronymic);
        this.initPartialSuggestions($patronymic, "PATRONYMIC", serviceUrl, token);
    },

    initPartialSuggestions($el, partName, serviceUrl, token) {
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            hint: false,
            noCache: true,
            params: { parts: [partName] },
            onSelect: this.showFio,
            onSelectNothing: this.guessFio,
            onSearchStart: this.enforceGender,
        };
        $el.suggestions(params);
    },

    getFullname() {
        return utils.join(
            [this.$refs.surname.value, this.$refs.name.value, this.$refs.patronymic.value],
            " ",
        );
    },

    showFio(suggestion) {
        this.fio = suggestion.data;
        service.enrich(this.getFullname())
            .done(fio => {
                this.fio = fio;
                this.fio.gender = helper.gender(fio);
            });
        Analytics.reachGoal("SUG_DEMO_FORM_NAME");
    },

    guessFio() {
        const fullname = this.getFullname();
        if (!fullname) {
            this.fio = null;
            return;
        }
        service.enrich(fullname)
            .done(fio => {
                this.fio = fio;
                this.fio.gender = helper.gender(fio);
            });
    },

    enforceGender(params) {
        if (!this.fio) {
            return;
        }
        let gender = "UNKNOWN";
        if (
            (params.parts[0] === "SURNAME" && this.fio.name) ||
            (params.parts[0] === "NAME" && this.fio.surname) ||
            (params.parts[0] === "PATRONYMIC" && (this.fio.surname || this.fio.name))
        ) {
            gender = this.fio.gender;
        }
        params.gender = gender;
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
        },
        computed: properties,
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const nameConfig = buildConfig(serviceUrl, token);

    createComponent(nameConfig, "#name-granular-vue-app");
}
